// src/App.js
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import Login from './Clients/Login';
import Portefeuille from './Clients/portefeuille';
import CarteVirtuelle from './Clients/carte';
import MonCompte from './Clients/compteClient';
import Virement from './Clients/virement';
import MenuClient from './Components/menuclient';
import ProtectedRoute from './Clients/ProtectedRoute';
import CGU from './Pages/CGU';
import Confidentialite from './Pages/Confidentialite';
import Donnees from './Pages/Donnees';
import Cookies from './Pages/Cookies';
import Footer from './Components/Footer';
import MultiStepForm from './Clients/register';

export default function App() {
  const location = useLocation();
  
  // Définir les routes publiques (avec footer)
  const publicRoutes = [
    "/",
    "/cgu",
    "/confidentialite",
    "/donnees",
    "/cookies",
    "/register"
  ];
  
  const isPublicRoute = publicRoutes.includes(location.pathname);
  const showFooter = isPublicRoute;
  const showMenu = !isPublicRoute && localStorage.getItem("bank.token");

  return (
    <div className="App flex flex-col min-h-screen">
      <div className="flex-grow">
        <Switch>
          {/* Page de connexion publique */}
          <Route exact path="/" component={Login} />

          {/* Pages d'information avec footer */}
          <Route path="/cgu" component={CGU} />
          <Route path="/confidentialite" component={Confidentialite} />
          <Route path="/donnees" component={Donnees} />
          <Route path="/cookies" component={Cookies} />
          <Route path="/register" component={MultiStepForm} />
          {/* Routes protégées */}
          <ProtectedRoute exact path="/banque/portefeuille" component={Portefeuille} />
          <ProtectedRoute exact path="/banque/carte" component={CarteVirtuelle} />
          <ProtectedRoute exact path="/banque/compte" component={MonCompte} />
          <ProtectedRoute exact path="/banque/virement" component={Virement} />

          {/* Redirection par défaut */}
          <Redirect to="/" />
        </Switch>

        {/* Afficher le menu uniquement sur les routes protégées */}
        {showMenu && <MenuClient />}
      </div>
      
      {/* Afficher le footer uniquement sur les routes publiques */}
      {showFooter && <Footer />}
    </div>
  );
}
